module.exports = __webpack_public_path__ + "static/media/linkedin_color.e41407a1.svg";